import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {Application} from "types/Application"

type ReturnedType = {
    status: "success"
    application: Application
}

export const fetchApplicationById = createAsyncThunk<ReturnedType, string, AppThunkProps>(
    "fetch/application/id",
    async (id, {signal}) => {
        return api.get<ReturnedType>(`/user/application/${id}`, {signal})
    }
)
